// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"p9-z"};